import React, { ReactNode } from 'react';

import { Box } from 'components/Box';
import { sectionPadding } from 'theme';

type Props = {
  belowBlocks: ReactNode | undefined;
  socialButtons: ReactNode | undefined;
  subscribeButton: ReactNode | undefined;
};

export function ContentPageBodyMainContentFooter({
  belowBlocks,
  socialButtons,
  subscribeButton,
}: Props) {
  return (
    <>
      {(socialButtons || subscribeButton) && (
        <Box mx="-6px" mb={[16, null, 24]} display="flex" id="subscribe">
          {socialButtons}
          {subscribeButton}
        </Box>
      )}

      {belowBlocks && (
        <Box m={sectionPadding} mt={[16, null, 24]}>
          {belowBlocks}
        </Box>
      )}
    </>
  );
}
